import React from 'react';

const Botany = () => {
  return (
    <div>
      Botany
      Botany
    </div>
  );
}

export default Botany;
